export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";